<template>
  <b-modal
    :id="id"
    :title="title"
    centered
    cancel-variant="white"
    ok-variant="danger"
    ok-title="Delete"
    v-on:ok="onConfirm"
  >
    <div class="alert alert-danger m-b-0">
      <slot name="content" />
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
      default: 'modalConfirm'
    },
    title: {
      type: String,
      required: false,
      default: 'Confirm delete'
    },
    onConfirm: {
      type: Function,
      required: true
    }
  }
}
</script>
